module.exports = __webpack_public_path__ + "img/img-search02.9573d8e5.jpg";